import React, { useState } from "react";
import PropTypes from "prop-types";

const FontInput = ({ frame, fontSettings, updateFontSize, templateSettings }) => {
  const [warningDelivered, updatedWarningDelivered] = useState(false);

  const originalFontSize = () => {
    try {
      return fontSettings[frame.id].size;
    } catch (err) {
      return null;
    }
  };

  const validateFontSize = (fontSize) => {
    if (!warningDelivered && fontSize && originalFontSize() && (fontSize > originalFontSize())) {
      Notify.makeAll('dormant');
      Notify.create({
        type: "error",
        title: t("Font size larger than original"),
        body: t("If text disappears, shrink font size.")
      });
      updatedWarningDelivered(true);
    }
  };

  const handleFontChange = (fontSize) => {
    validateFontSize(parseInt(fontSize, 10));
    updateFontSize(fontSize);
  };

  if (templateSettings.allowFontSizing) {
    return (
      <div className="font-size-input">
        <label className="bf-label bf-label--primary" htmlFor={`${frame.id}-fontSize`}>
          {t("Font Size (px)")}
        </label>
        <input
          defaultValue={originalFontSize()}
          onChange={(e) => handleFontChange(e.target.value)}
          type="number"
        />
      </div>
    );
  }

  return null;
};

FontInput.propTypes = {
  frame: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  updateFontSize: PropTypes.func.isRequired,
  fontSettings: PropTypes.shape({}).isRequired,
  templateSettings: PropTypes.shape({
    allowFontSizing: PropTypes.bool
  }).isRequired,
};

export default FontInput;
